import { createFileRoute, Outlet } from '@tanstack/react-router';
import { clientGuard } from '@/lib/route-guards';

export const Route = createFileRoute('/client/quotes/$id')({
  beforeLoad: clientGuard,
  component: QuoteIdLayout,
});

// Layout component that renders child routes (index or edit)
function QuoteIdLayout() {
  return <Outlet />;
}
